import { render } from "./CSDPagination.vue?vue&type=template&id=dc85c042&scoped=true"
import script from "./CSDPagination.vue?vue&type=script&lang=js"
export * from "./CSDPagination.vue?vue&type=script&lang=js"

import "./CSDPagination.vue?vue&type=style&index=0&id=dc85c042&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc85c042"]])

export default __exports__